<div class="surface-ground flex align-items-center justify-content-center min-h-screen">
    <div class="flex flex-column align-items-center">
        <!-- Logo -->
        <img src="assets/images/app_logo.png" alt="Logo" class="mb-5" width="150">
        
        <!-- Button -->
        <p-button 
            label="API Documentation" 
            icon="pi pi-external-link" 
            (onClick)="openSwaggerDocs()"
            styleClass="p-button-raised p-button-lg">
        </p-button>

        <!--
        <p-button
            label="Open Database" 
            icon="pi pi-external-link" 
            (onClick)="openDatabase()"
            styleClass="p-button-raised p-button-lg"
            class="mt-2">
        </p-button>
        -->
    </div>
</div>
